export default function lowerCase(value) {
  return value?.trim().toLowerCase();
}
